<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Edit Document Title </h5>
      <form [formGroup]="EditDocumentTitle" (submit)="SubmitEditDocumentTitle()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Title</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">Please enter a title.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Document Group  </label>
            <select class="custom-select" formControlName="GroupId" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_DocumentGroup" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
        </div>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!EditDocumentTitle.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
        <button routerLink="/DocumentTitle" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

